<header id="header" class="admin-header">
  <div class="left-side-menu hamburger-menu" (click)="toggleSidebar()">
    <svg viewBox="0 0 100 80" width="30" height="30" style="fill: #f58634;">
      <rect width="100" height="15" rx="8"></rect>
      <rect y="30" width="100" height="15" rx="8"></rect>
      <rect y="60" width="100" height="15" rx="8"></rect>
    </svg>
  </div>
  <div class="right-side-menu">
    <span class="notify">
      <img matTooltip="Notifications" src="../../../assets/img/bell.svg" (click)="GoToActivity()" />
      <p class="notification">{{ totalIndex }}</p>
    </span>
    <span>
      <div class="dropdown" style="cursor: pointer" matTooltip="Profile">
        <a mat-button [matMenuTriggerFor]="menu"><img class="header-profile"
            src="{{ profilePic ? profilePic : 'assets/img/profilesimg.svg' }}" />Hi, {{ userName }}
        </a>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="GoToProfile()">Profile</button>
          <div class="seperator"></div>
          <button mat-menu-item (click)="logout()">Logout</button>
        </mat-menu>
      </div>
    </span>
  </div>
</header>